import { RGBColor } from 'react-color';

export const getColorFromString = (color?: string): string  => {
  try {
    if (!color) {
      return '';
    }

    const parsedColor = JSON.parse(color) as RGBColor;
    return `rgba(${String(parsedColor.r)},${String(parsedColor.g)},${String(parsedColor.b)},${String(parsedColor.a)})`;
  } catch(exception) {
    console.error(exception);
  }
  return '';
};
